// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2jof0","footer":"ModalUpdate_footer__3WC8r"};